import { CourseIndexInfo } from '@protos/content_management/content.common.apis_pb';
import { TeacherAssessmentReportData } from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import { createSlice } from '@reduxjs/toolkit';
import { AssessmentEnum } from '@protos/learning_management/lms.db_pb';
import { set } from 'video.js/dist/types/tech/middleware';
interface Chapter {
  chapterId: number;
  chapterTitle: string;
  chapterNo: number;
}

interface IAssessmentTypes {
  name: string;
  id: AssessmentEnum;
}

interface Topic {
  topicId: number;
  topicTitle: string;
}
interface ITeacherReportState {
  reportData?: TeacherAssessmentReportData | undefined;
  selected_chapter?: Chapter;
  selected_topic?: Topic;
  chapter_topic_data?: CourseIndexInfo;
  searchByAssessType: IAssessmentTypes | undefined;
  pageNumber: number;
}

const initialState: ITeacherReportState = {
  reportData: undefined,
  selected_chapter: undefined,
  selected_topic: undefined,
  chapter_topic_data: undefined,
  searchByAssessType: undefined,
  pageNumber: 1,
};

export const teacherReportSlice = createSlice({
  name: 'teacherReport',
  initialState,
  reducers: {
    setReportsData: (state, action) => {
      state.reportData = action.payload;
    },
    setSelectedChapter: (state, action) => {
      state.selected_chapter = action.payload;
    },
    setSelectedTopic: (state, action) => {
      state.selected_topic = action.payload;
    },
    setCourseIndexInfo: (state, action) => {
      state.chapter_topic_data = action.payload;
    },
    setSearchByAssessType: (state, action) => {
      state.searchByAssessType = action.payload;
    },
    setPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    resetSelectedReportChapter: (state) => {
      state.selected_chapter = undefined;
    },
    resetSelectedReportTopic: (state) => {
      state.selected_topic = undefined;
    },
    resetReportState: (state) => {
      return initialState;
    },
  },
});

export const {
  setReportsData,
  setSelectedChapter,
  setSelectedTopic,
  setCourseIndexInfo,
  setPageNumber,
  resetSelectedReportChapter,
  resetSelectedReportTopic,
  setSearchByAssessType,
  resetReportState,
} = teacherReportSlice.actions;

export default teacherReportSlice.reducer;
